// extracted by mini-css-extract-plugin
export default {"form":"_4peFq95zwU9sLOcSPvR06Q","form--changed":"_1nT3rTsUb1MC7s1c0WQmzE","form--loading":"op25jsS0qtp5ewo9iSGDw","spinner":"_2a7sc1HXolu3Hl6zZ9Ca4q"};